module.exports = __webpack_public_path__ + "static/media/sim_deactivation_banner.f41a2c2d.png";